import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { mockTestimonials } from './mock';

const TestimonialsSection = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star 
        key={index} 
        className={`w-5 h-5 ${
          index < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
        }`} 
      />
    ));
  };

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e1919] mb-6 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
            Client 
            <span className="bg-gradient-to-r from-[#5f9dff] to-[#61525a] bg-clip-text text-transparent">Success Stories</span>
          </h2>
          <p className="text-lg text-[#736c64] max-w-3xl mx-auto leading-relaxed">
            Hear from our satisfied clients who have transformed their businesses and academic journeys with our expertise.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockTestimonials.map((testimonial) => (
            <Card 
              key={testimonial.id} 
              className="group hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 border-0 bg-gradient-to-br from-white to-gray-50/50 backdrop-blur-sm relative overflow-hidden"
            >
              {/* Quote Icon Background */}
              <div className="absolute top-4 right-4 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
                <Quote className="w-16 h-16 text-[#5f9dff]" />
              </div>
              
              <CardContent className="p-8 relative">
                {/* Rating */}
                <div className="flex space-x-1 mb-6">
                  {renderStars(testimonial.rating)}
                </div>
                
                {/* Content */}
                <blockquote className="text-[#736c64] leading-relaxed mb-6 italic">
                  "{testimonial.content}"
                </blockquote>
                
                {/* Author */}
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full overflow-hidden ring-2 ring-[#5f9dff]/20 mr-4">
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.name} 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-[#1e1919] font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-[#5f9dff] font-medium">{testimonial.title}</p>
                    <p className="text-sm text-[#736c64]">{testimonial.company}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-20">
          <div className="bg-gradient-to-r from-[#5f9dff]/10 to-[#61525a]/10 rounded-3xl p-8 backdrop-blur-sm border border-white/50">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-[#61525a] mb-2 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
                  100+
                </div>
                <div className="text-[#736c64] font-medium">Projects Delivered</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#61525a] mb-2 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
                  50+
                </div>
                <div className="text-[#736c64] font-medium">Happy Clients</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#61525a] mb-2 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
                  98%
                </div>
                <div className="text-[#736c64] font-medium">Success Rate</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-[#61525a] mb-2 font-['Dbsharpgroteskvariable_Vf',_Arial,_sans-serif]">
                  24h
                </div>
                <div className="text-[#736c64] font-medium">Response Time</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { TestimonialsSection };